import React from "react";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../../../Components/Common/ChartsDynamicColor";

const RevenueCharts = ({ dataColors, series }) => {
  // console.log("Series data received:", series); // Debug log
  
  // Transform series data to fit ApexCharts format
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  // Ensure series is an array and has data
  const seriesData = Array.isArray(series) ? series : [];
  
  // Create an array of totalSales for each month (0 for months with no data)
  const totalSalesData = months.map((_, index) => {
    const monthIndex = index + 1; // Months are 1-based in your API
    const monthData = seriesData.find(item => item.month === monthIndex);
    const value = monthData ? Math.round(monthData.totalSales / 1000 * 100) / 100 : 0; // Convert to thousands and round to 2 decimals
    // console.log(`Month ${monthIndex}: ${value}`); // Debug log
    return value;
  });

  const chartSeries = [
    {
      name: "Total Sales (k)",
      data: totalSalesData,
    },
  ];

  // console.log("Chart series:", chartSeries); // Debug log

  // Get colors or use default
  // const linechartcustomerColors = dataColors ? 
  //   getChartColorsArray(dataColors) : ['#5cb85c', '#5cb85c', '#5cb85c'];

  const linechartcustomerColors = dataColors
  ? getChartColorsArray(dataColors)
  : ["#28a745", "#007bff", "#dc3545"]; // vivid green, blue, red


  const options = {
    chart: {
      height: 370,
      type: "line",
      toolbar: {
        show: false,
      },
    },
    stroke: {
      curve: "smooth",
      dashArray: [0],
      width: [3],
    },
    fill: {
      opacity: [0.1],
    },
    markers: {
      size: [4],
      strokeWidth: 2,
      hover: {
        size: 6,
      },
    },
    xaxis: {
      categories: months,
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
    },
    yaxis: {
      title: {
        text: 'Sales (in thousands Rs)'
      },
      min: 0,
      labels: {
        formatter: function (value) {
          return value.toFixed(1) + "k";
        }
      }
    },
    grid: {
      show: true,
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
      padding: {
        top: 0,
        right: -2,
        bottom: 15,
        left: 10,
      },
    },
    legend: {
      show: true,
      horizontalAlign: "center",
      offsetX: 0,
      offsetY: -5,
      markers: {
        width: 9,
        height: 9,
        radius: 6,
      },
      itemMargin: {
        horizontal: 10,
        vertical: 0,
      },
    },
    colors: linechartcustomerColors,
    tooltip: {
      shared: true,
      y: [
        {
          formatter: function (y) {
            if (typeof y !== "undefined" && y !== null) {
              return "Rs." + y.toFixed(1) + "k";
            }
            return y;
          },
        },
      ],
    },
    // Add responsive options
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          height: 300
        }
      }
    }]
  };

  return (
    <React.Fragment>
      <ReactApexChart
        dir="ltr"
        options={options}
        series={chartSeries}
        type="line"
        height="370"
        className="apex-charts"
      />
    </React.Fragment>
  );
};

const StoreVisitsCharts = ({ dataColors }) => {
  var chartDonutBasicColors = getChartColorsArray(dataColors);

  const series = [44, 55, 41, 17, 15];
  var options = {
    labels: ["Direct", "Social", "Email", "Other", "Referrals"],
    chart: {
      height: 333,
      type: "donut",
    },
    legend: {
      position: "bottom",
    },
    stroke: {
      show: false,
    },
    dataLabels: {
      dropShadow: {
        enabled: false,
      },
    },
    colors: chartDonutBasicColors,
  };
  return (
    <React.Fragment>
      <ReactApexChart
        dir="ltr"
        options={options}
        series={series}
        type="donut"
        height="333"
        className="apex-charts"
      />
    </React.Fragment>
  );
};

export { RevenueCharts, StoreVisitsCharts };